import React, { FC, useMemo } from "react";

import { toDisplayRect } from "@/sx-layout/components/settings/plotPlanMapping/util/plotPlanMappingAdapter";
import { PlotPlanMapping } from "@/sx-layout/hooks/usePlotPlanMappingApi";
import { normalizeHexColor } from "@/sx-layout/utils";

type Props = {
  id?: string;
  plotPlanMapping: PlotPlanMapping;
  mapRatio: number;
  onClick?: (e: React.MouseEvent) => void;
  onDoubleClick?: () => void;
};

export const PlotPlanDetailArea: FC<Props> = ({ id, plotPlanMapping, mapRatio, onClick, onDoubleClick }) => {
  const rect = toDisplayRect(plotPlanMapping);
  const color = useMemo(() => normalizeHexColor(plotPlanMapping.color), [plotPlanMapping]);
  const backgroundImage = useMemo(() => {
    const light = `${color}1A`;
    const dark = `${color}4d`;
    return `repeating-linear-gradient(-45deg, ${light} 0px, ${light} 0.5px, ${dark} 1px, ${dark} 5px, ${light} 5.5px, ${light} 6px)`;
  }, [color]);

  return (
    <div
      id={id}
      className="absolute cursor-pointer"
      style={{
        top: rect.top * mapRatio,
        left: rect.left * mapRatio,
        width: rect.width * mapRatio,
        height: rect.height * mapRatio,
        transform: `rotate(${rect.rotation}deg)`,
      }}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
        <div className="pointer-events-none absolute inset-0" style={{ backgroundImage }} />
      </div>
    </div>
  );
};
